import { FC, ReactNode } from "react";
import { Box, Container, useTheme } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";

import Sidebar from "./Sidebar";
import Toggle from "./Header/Toggle";
import Breadcrumb from "src/components/common/Breadcrumb";
import PageHeader from "src/components/common/PageHeader";
import BottomNavigation from "./BottomNavigation";
import NetworkStatus from "src/components/common/NetworkStatus";
import Logo from "src/components/common/LogoSign";
import Chatbot from "src/components/learning/Chatbot";

interface SidebarLayoutProps {
	children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
	const theme = useTheme();
	const isMobile = localStorage.getItem("isMobile");
	const location = useLocation();

  // Pola URL yang ingin dicocokkan
  const urlPattern = /^\/classes\/e-course\/\d+(\/\d+){1,3}$/;

	return (
		<>
			<Box
				sx={{
					flex: 1,
					height: "100%",
					".MuiPageTitle-wrapper": {
						background:
							theme.palette.mode !== "dark"
								? theme.colors.alpha.trueWhite[5]
								: theme.colors.alpha.white[50],
						marginBottom: `${theme.spacing(4)}`,
					},
				}}>
				{/* <Header /> */}
				{
					((isMobile == "false" || isMobile == undefined) || urlPattern.test(location.pathname)) &&
					<>
						<Box
							sx={{
								display: { lg: "none", xs: "flex" },
								alignItems: "center",
								justifyContent: "space-between",
								pr: 2,
							}}>
							<Toggle />
							<Box sx={{ mr: -2 }}>
								<Logo scale={0.7} />
							</Box>
						</Box>
						<Sidebar />
					</>
				}
				<Box
					sx={{
						position: "relative",
						zIndex: 5,
						display: "block",
						flex: 1,
						pt: `${theme.spacing(0)}`,
						pb: { xs: `${theme.spacing(8)}`, lg: `${theme.spacing(2)}` },
						[theme.breakpoints.up("lg")]: {
							ml: `${theme.sidebar.width}`,
							pl: `20px`,
							pt: `${theme.spacing(4)}`,
						},
					}}>
					<Container maxWidth="lg">
						<NetworkStatus />
						<Box display="block">
							{
								(isMobile == "false" || isMobile == undefined) ?
								<Breadcrumb />
								:
								<div style={{marginTop: "20px"}}></div>
							}
							<PageHeader />
							<Outlet />
						</Box>
					</Container>
				</Box>
				<Box sx={{ display: { xs: "block", lg: "none" } }}>
					{(isMobile == "false" || isMobile == undefined) && <BottomNavigation />}
				</Box>
				{((isMobile == "false" || isMobile == undefined) && 
				(!(location.pathname.includes("/classes/tryout/") || location.pathname.includes("/all-menu")) || 
				/^\/classes\/tryout\/\d+\/analytic$/.test(location.pathname))) && <Chatbot />}
			</Box>
		</>
	);
};

export default SidebarLayout;
